import { Directive, HostListener, Input } from '@angular/core';
import { NavbarService } from './navbar.service';
import { NavbarComponent } from './navbar/navbar.component';

@Directive({
    selector: '[ngcNavbar]'
})
export class NavbarToggleDirective {
    @Input() ngcNavbar: string;
    navbar: NavbarComponent;

    constructor(private navbarService: NavbarService) {
    }

    @HostListener('click')
    onClick() {
        this.navbar = this.navbarService.getNavBar();

        if ( !this.navbar[this.ngcNavbar] ) {
            return;
        }

        this.navbar[this.ngcNavbar]();
    }
}
